import 'rc-tooltip/assets/bootstrap.css';
import 'rc-slider/assets/index.css';
import './App.css';
import React from 'react'
import _ from 'lodash';
import $ from 'jquery';
import Slider, { SliderTooltip } from 'rc-slider';
import KeywordInput from './keyword-input'
import KeywordExamples from './keyword-examples'
import { wordCountToColor, wordCountToWidth, numberWithCommas } from './helpers'
import Switch from "react-switch";
// import testData from './test-data'
var testData = null;

const { Handle } = Slider;

const handle = props => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <SliderTooltip
      prefixCls="slider-tooltip"
      overlay={`${numberWithCommas(value)}`}
      visible={true}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </SliderTooltip>
  );
};

class App extends React.Component{

    constructor(props){
      super(props);

      this.state = {
        keyword: '',
        submittedKeyword: '',
        competitors: [],
        recommended_word_count: null,
        error: '',
        isLoading: false,
        content_word_count: 0,
        showPositions: false
      }
    
      this.handleCalculate = this.handleCalculate.bind(this);
      this.handleSliderChange = this.handleSliderChange.bind(this);
      this.toggleShowPositions = this.toggleShowPositions.bind(this);
      // this.rootUrl = 'http://localhost:3000';
      this.rootUrl = 'https://app.usetopic.com';
    }

    componentDidMount(){
      if(testData && _.isObject(testData)){
        this.setState({
          competitors: testData.competitors,
          recommended_word_count: testData.recommended_word_count,
          content_word_count: testData.recommended_word_count,
          isLoading: false,
          error: '',
          keyword: "test",
          submittedKeyword: "test"
        });
      }
    }

    handleCalculate(e){
      var that = this;
      var {keyword, isLoading} = this.state;

      if(_.isString(e)){
        keyword = e; // called from keyword-examples
        that.setState({keyword: keyword});
      } else{
        e.preventDefault();
      }
      
      if(isLoading){
        alert('Please wait while we calculate the optimal word count for your keyword. This may take a minute.');
        return;
      } else if(keyword.trim().length === 0){
        alert('Please enter a valid keyword.');
        return;
      }
      this.setState({
        isLoading: true
      })
      fetch(`${this.rootUrl}/api/tools/word_count?keyword=${encodeURIComponent(keyword)}`)
        .then(response => response.json())
        .then((response) => {
          if(response.error){
            that.setState({
              error: response.error,
              isLoading: false
            })
          } else if(response.competitors && response.recommended_word_count){
            that.setState({
              competitors: response.competitors,
              recommended_word_count: response.recommended_word_count,
              content_word_count: response.recommended_word_count,
              isLoading: false,
              error: '',
              submittedKeyword: keyword
            })
          } else{
            that.setState({
              error: 'Something went wrong getting the recommendation. Please contact support@usetopic.com',
              isLoading: false
            })
          }
        });
    }

    handleSliderChange(value){
      this.setState({
        content_word_count: value
      });
    }

    toggleShowPositions(){
      this.setState({
        showPositions: !this.state.showPositions
      })
    }

    render(){
      var that = this;
      var {keyword, isLoading, error, competitors, recommended_word_count, content_word_count, submittedKeyword, showPositions} = this.state;
      var showResults = !isLoading && !_.isEmpty(competitors) && _.isNumber(recommended_word_count);
      var maxWordCount, longerThanPercentage;

      if(showResults){
        maxWordCount = _.max(_.map(competitors, "word_count"));
        longerThanPercentage = Math.round((_.filter(competitors, (competitor) => { return content_word_count > (competitor.word_count || 0) }).length / competitors.length)*100);
        competitors = _.cloneDeep(competitors);
        competitors.push({
          word_count: content_word_count,
          position: -1
        });
        if(showPositions){
          competitors = _.sortBy(competitors, (competitor) => { return competitor.position; });
        } else{
          competitors = _.sortBy(competitors, (competitor) => { return -1 * competitor.word_count; });
        }
        $('.section-blogpost-length').addClass('active');
      } else{
        $('.section-blogpost-length').removeClass('active');
      }


      return (

        <div className="App">
          <KeywordInput keyword={keyword} onClick={this.handleCalculate} onChange={(e) => {that.setState({keyword: e.target.value});}} isLoading={isLoading} />
          <KeywordExamples onClick={(keyword) => { this.handleCalculate(keyword); }} />
          {error && <div className="error" style={{color: 'red', textAlign: 'center'}}>{error}</div>}

          {showResults && <React.Fragment>
            <div className="animated fadeIn" style={{marginBottom: '30px', textAlign: 'center'}}>
              <img src="images/down-arrow.svg" loading="lazy" alt="" className="down-arrow" style={{display: 'inline-block'}} />
            </div>
            <div className="bpl-row-2 animated fadeIn delay-1">
              <div className="p-big">According to our analysis, the ideal word count for a blog post targeting “<strong>{submittedKeyword}</strong>” is between<strong className="bottom-border"> {recommended_word_count} and {recommended_word_count+300} words</strong>.</div>
              <div className="p normal" style={{marginTop: '100px'}}>Use the slider below to fine tune your word count by comparing with other top ranking articles:</div>
            </div>
            <div className="bpl-row-3 animated fadeIn delay-2">

              <div className="slider-wrapper">
                <div className={`slider-box ${wordCountToColor(content_word_count, recommended_word_count)}`} style={{ display: 'inline-block'}}>
                  <Slider
                    className="topic-slider"
                    handle={handle}
                    max={Math.round(maxWordCount/100)*100+200}
                    step={100}
                    defaultValue={recommended_word_count}
                    onChange={this.handleSliderChange}
                   />
                  <div className="p small" style={{marginTop: '10px'}}>If your content was {numberWithCommas(content_word_count)} words, <br /> it would be longer than {longerThanPercentage}% of competitors</div>
                </div>
              </div>

              <div className="table-wrapper">
                <div className="table-title-box">
                  <div className="table-title-text">Top Ranking Articles for “{submittedKeyword}” <span className="normal-text">(by word count)</span></div>
                  <div style={{display: 'flex'}}>
                    <div style={{marginRight: '10px'}}>
                      Order by Rankings
                    </div>
                    <Switch
                      onChange={this.toggleShowPositions}
                      checked={showPositions}
                      onColor="#86d3ff"
                      onHandleColor="#2693e6"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={40}
                    />
                  </div>
                </div>
                <div className={`table-box ${showPositions ? 'table-box-with-positions' : ''}`}>
                  {_.map(competitors, (competitor, i) => {
                    if(competitor.title){
                      return (
                        <div className="table-row" key={i}>
                          {showPositions && <div className="table-col-0">
                              <div className="table-col-position">
                                {competitor.position}
                              </div>
                          </div>}
                          <div className="table-col-1">
                            <div className="table-col-title">{competitor.title}</div>
                            <div className="table-col-subtext"><a href={competitor.link} target="_blank">{competitor.link}</a></div>
                          </div>
                          <div className="table-col-2">
                            <div className={`table-col-2-inner ${wordCountToColor(competitor.word_count, recommended_word_count)}`} style={{width: wordCountToWidth(competitor.word_count, maxWordCount)}}>
                              <div className="table-col-number">{numberWithCommas(competitor.word_count) || "NA"}</div>
                            </div>
                          </div>
                        </div>
                      );
                    } else{
                      return (
                        <div className="table-row yourcontent" key={i}>
                          <div className="table-col-1 yourcontent">
                            <div className="table-col-title big">Your Content </div>
                          </div>
                          <div className="table-col-2 yourcontent">
                            <div className={`table-col-2-inner animate-all ${wordCountToColor(competitor.word_count, recommended_word_count)}`} style={{width: wordCountToWidth(competitor.word_count, maxWordCount)}}>
                              <div className="table-col-number">{numberWithCommas(content_word_count)}</div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>

          </React.Fragment>}
        </div>
      );
    }

}

export default App